import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import { useEffect, useState } from "react";
import {
  load_user_data_from_id,
  register_profile,
  update_profile,
} from "../../actions/user_content";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission } from "../../hooks/userPermissions";

const initialProfileData = {
  email: "",
  password1: "",
  password2: "",
  rut: "",
  name: "",
  first_lastname: "",
  second_lastname: "",
  phone: "",
  occupation: "",
  profile_type: "CLI",
};
const CreateProfileModal = (props) => {
  const { show, onHide, profileId, userData } = props;
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [profileData, setProfileData] = useState(initialProfileData);
  const [formAlerts, setFormAlerts] = useState({
    rut: false,
    name: false,
    first_lastname: false,
    email: false,
    password1: false,
    password2: false,
  });

  const checkEmptyFields = (keyList) => {
    let isEmpty = false;
    const newFormData = { ...profileData };
    keyList.forEach((key) => {
      if (profileData[key].toString().trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }

      setTimeout(() => {
        setFormAlerts({ name: false, rut: false, first_lastname: false });
      }, 3500);
    });

    setProfileData(newFormData);
    return isEmpty;
  };
  const submitProfile = async () => {
    dispatch(checkAuthenticated());
    await register_profile(profileData);
  };
  const updateProfile = async () => {
    dispatch(checkAuthenticated());
    await update_profile(profileData, profileId);
  };
  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value,
    });
  };
  const hideModal = () => {
    setProfileData(initialProfileData);
    onHide();
  };
  const handleSubmit = () => {
    if (
      !checkEmptyFields([
        "rut",
        "name",
        "first_lastname",
        "email",
        "password1",
        "password2",
      ])
    ) {
      submitProfile();
      hideModal();
    }
  };
  const handleEdit = () => {
    if (!checkEmptyFields(["rut", "name", "first_lastname", "email"])) {
      updateProfile();
      hideModal();
    }
  };
  const submitButtons = {
    create: () => (
      <Button variant="primary" onClick={handleSubmit}>
        Agregar
      </Button>
    ),
    edit: () => (
      <Button variant="primary" onClick={handleEdit}>
        Guardar Cambios
      </Button>
    ),
  };

  useEffect(() => {
    const setData = async () => {
      if (profileId) {
        const data = await load_user_data_from_id(profileId);
        if (data) {
          setProfileData(data);
        }
      }
    };

    setData();
  }, []);
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="justify-content-center"
        >
          Nuevo Perfil
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-between">
          <div className="col">
            <div className="d-flex flex-wrap gap-2">
              <div className="input-field flex-fill">
                <label htmlFor="emailFormControlInput" className="form-label">
                  Correo
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.email ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={profileData.email}
                  className={
                    formAlerts.email
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="emailFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div
                className={`input-field flex-fill ${profileId ? "d-none" : ""}`}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <label className="form-label m-0">
                    Contraseña
                    <strong className="text-danger">*</strong>
                  </label>
                  <Button variant="outline-secondary" size="sm">
                    Autogenerar
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => setPasswordVisible(!isPasswordVisible)}
                    size="sm"
                  >
                    {isPasswordVisible ? "Ocultar" : "Mostrar"}
                  </Button>
                  <span
                    className={
                      formAlerts.password1
                        ? "fst-italic m-2 text-danger"
                        : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </div>
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="password1"
                  value={profileData.password1}
                  className={
                    formAlerts.password1
                      ? "border border-danger form-control mb-2"
                      : "form-control mb-2"
                  }
                  onChange={(e) => handleChange(e)}
                />
                <label className="form-label">
                  Confirmar Contraseña
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.password2
                        ? "fst-italic m-2 text-danger"
                        : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="password2"
                  value={profileData.password2}
                  className={
                    formAlerts.password2
                      ? "border border-danger form-control mb-2"
                      : "form-control mb-2"
                  }
                  onChange={(e) => handleChange(e)}
                />
              </div>

              <div className="input-field flex-fill">
                <label htmlFor="nameFormControlInput" className="form-label">
                  Nombre
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.name ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={profileData.name}
                  className={
                    formAlerts.name
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="nameFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>

              <div className="input-field flex-fill">
                <label htmlFor="rutFormControlInput" className="form-label">
                  Rut
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.rut ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  name="rut"
                  value={profileData.rut}
                  className={
                    formAlerts.rut
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="rutFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>

              <div className="input-field flex-fill">
                <label
                  htmlFor="first_lastnameFormControlInput"
                  className="form-label"
                >
                  Primer Apellido
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.first_lastname
                        ? "fst-italic m-2 text-danger"
                        : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  name="first_lastname"
                  value={profileData.first_lastname}
                  className={
                    formAlerts.first_lastname
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="first_lastnameFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-field flex-fill">
                <label
                  htmlFor="second_lastnameFormControlInput"
                  className="form-label"
                >
                  Segundo Apellido
                </label>
                <input
                  type="text"
                  name="second_lastname"
                  value={profileData.second_lastname}
                  className="form-control"
                  id="second_lastnameFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="phoneFormControlInput" className="form-label">
                  Telefono
                </label>
                <input
                  type="text"
                  name="phone"
                  value={profileData.phone}
                  className="form-control"
                  id="phoneFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>

              <div className="input-field flex-fill">
                <label
                  htmlFor="occupationFormControlInput"
                  className="form-label"
                >
                  Ocupacion
                </label>
                <input
                  type="text"
                  name="occupation"
                  value={profileData.occupation}
                  className="form-control"
                  id="occupationFormControlInput"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="typeFormControlInput" className="form-label">
                  Modelo Perfil
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  name="profile_type"
                  onChange={(e) => handleChange(e)}
                  value={profileData.profile_type}
                  disabled={user.profile_type != "ADM"}
                >
                  <option value="">N/A</option>
                  <option value="CLI">Clinica</option>
                  <option value="CYG">Clinica y Gerencia</option>
                  <option value="ADM">Administrador</option>
                  <option value="MOD">Moderador</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={() => hideModal()}>
          Cancelar
        </Button>
        {profileId
          ? hasPermission(user, "update:profile") && submitButtons.edit()
          : hasPermission(user, "create:profile") && submitButtons.create()}
      </Modal.Footer>
    </Modal>
  );
};

export default CreateProfileModal;
